import { StructuredStorageSlots } from '../../constants';
import { Helper } from '../Helper';
export class PutArrayStorageLengthHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapArrayStorage);
        sb.emitPushInt(node, StructuredStorageSlots.prefix);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.putCommonStorage);
    }
}

//# sourceMappingURL=PutArrayStorageLengthHelper.js.map
